import React from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useTheme, useMediaQuery, Grid, Link, List, ListItem } from '@mui/material';

// Custom Components
import PublicPage from '@/ui/PublicPage/PublicPage';

function DataSourcesPage() {
  const { t } = useTranslation();

  const theme = useTheme();
  const isMobile: boolean = useMediaQuery(theme.breakpoints.down('md'));

  const paragraphs = [1, 2, 3, 4, 5, 6, 7, 8, 9];

  return (
    <PublicPage overrideBgImage>
      <Box width='100%'>
        <Container maxWidth='xxl' style={{ padding: 0 }}> 
          <Grid container p={isMobile ? 3 : 10}>
            <Grid size={{xs: 12, md: 5, lg: 3}}>
              <Typography
                color='primary'
                variant='h4'
                component='h1'
                sx={{
                  position: !isMobile ? 'fixed' : 'unset',
                }}
              >
                {t('public.headings.data_sources')}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 7, lg: 5 }} container mt={isMobile ? 2 : 0} columnGap='50px'>
              <Box textAlign='left' mt={isMobile ? 2 : 0}>
                <Typography variant="body1" maxWidth='700px'>
                  {t('public.data_sources_description')}
                </Typography>

                {paragraphs.map((index) => (
                  <Box mt={3} key={`data-source-section-${index}`}>
                      <Typography fontWeight={600} variant="body1">
                        {t(`public.data_sources_link_${String(index)}`) !== 'None' ? (
                          <Link href={t(`public.data_sources_link_${String(index)}`)} underline="hover" target="_blank">
                            {t(`public.data_sources_source_${String(index)}`)}
                          </Link>
                        ) : (
                          t(`public.data_sources_source_${String(index)}`)
                        )}
                      </Typography>
                    <List sx={{ listStyleType: 'disc', padding: 0 }}>
                      {t(`public.data_sources_text_${String(index)}`)
                        .split(',')
                        .map((x, i) => <ListItem
                              key={`data-source-section-${index}-list-${i}`}
                              sx={{ display: 'list-item', padding: 0, color: 'primary.main', fontSize: '0.875rem' }}
                            >
                              <Typography color="black">{x}</Typography>
                            </ListItem>
                        )}
                    </List>
                  </Box>
                ))}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </PublicPage>
  );
}

export default DataSourcesPage;
